import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["field"]

  connect() {
    // Initialize the field state based on checkbox
    this.toggleField()
  }

  toggleField() {
    const checkbox = this.element.querySelector('#same_name_checkbox') as HTMLInputElement
    const field = this.element.querySelector('#network_name_field') as HTMLInputElement
    
    if (!checkbox || !field) return

    if (checkbox.checked) {
      // Disable the field and clear its value
      field.disabled = true
      field.value = ''
      field.classList.add('opacity-50', 'cursor-not-allowed')
      field.classList.remove('input-bordered')
      field.classList.add('input-disabled')
    } else {
      // Enable the field
      field.disabled = false
      field.classList.remove('opacity-50', 'cursor-not-allowed', 'input-disabled')
      field.classList.add('input-bordered')
    }
  }
}
